<template>
  <v-container class="floors-footer ma-0 pa-2 px-md-12 pb-md-0" :class="{'gucci-app': $root.isApp }" fluid>
    <v-row v-show="!showFloorsMap" align="center" class="pa-0 pa-sm-2 mb-1">
      <v-col
        cols="6"
        md="4"
        offset-md="4"
        class="text-md-center"
      >
        <button
          @click="mapButtonClick"
          class="button-map capitalize underline hover-letter-spacing"
        >
          <h4 class="regular">{{ $root.allLanguages[$language.current].map }}</h4>
        </button>
      </v-col>
      <v-col cols="6" md="4">
        <Audioguide />
      </v-col>
    </v-row>
    <v-row class="footer-row ma-0 py-3" :class="{'border-top': !showFloorsMap}" align="center">
      <v-col
        v-show="!showFloorsMap"
        cols="3"
        md="4"
        lg="3"
        class="pa-0 pa-sm-2 py-md-2"
      >
        <a
          @click="trackFooter('Privacy Policy')"
          :href="`${$root.allSettings[$language.current + 'PrivacyPolicyUrl']}`"
          target="_blank"
          class="mr-md-6 text-no-wrap"
        >
          {{ $root.allLanguages[$language.current].privacyFooterLabelCta }}
        </a>
        <a
          @click="trackFooter('Cookie Policy')"
          :href="`static/cookie/${$language.current}.html`"
          target="_blank"
          class="text-no-wrap"
        >
          {{ $root.allLanguages[$language.current].cookieFooterLabelCta }}
        </a>
        <a
          @click="trackFooter('Terms and Codition')"
          :href="$root.allSettings.termsAndConditionsUrl"
          target="_blank"
          class="mobile-only mr-md-6 text-no-wrap"
        >
          {{ $root.allLanguages[$language.current].termsFooterLabelCta }}
        </a>
      </v-col>
      <v-col
        class="pa-0 pa-sm-2 py-md-2"
        :cols="!showFloorsMap ? 6 : 9"
        :md="!showFloorsMap ? 4 : 8"
        :lg="!showFloorsMap ? 6 : 9"
      >
        <MapLocation
          :currentFloorOver="currentFloorOver"
          :showFloorsMap="showFloorsMap"
          :currentRoomOver="currentRoomOver"
        />
      </v-col>
      <v-col
        cols="3"
        md="4"
        lg="3"
        align="end"
        justify="center"
        class="pa-0 pa-sm-2 py-md-2"
      >
        <a @click="trackFooter('Terms and Codition')" :href="$root.allSettings.termsAndConditionsUrl" target="_blank" class="desktop-only mr-md-6 text-no-wrap">{{ $root.allLanguages[$language.current].termsFooterLabelCta }}</a>
        <MapSocial />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MapLocation from '../atoms/MapLocation.vue'
import MapSocial from '../atoms/MapSocial.vue'
import Audioguide from '@/atoms/Audioguide.vue'

export default {
  name: 'Footer',

  components: {
    MapSocial, MapLocation, Audioguide
  },

  props: {
    showFloorsMap: {
      type: Boolean
    },
    currentRoomOver: {
      type: String
    },
    currentFloorOver: {
      type: String
    }
  },
  methods: {
    mapButtonClick () {
      this.$emit('onMapFloorClick')
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'generic_event',
          eventCategory: 'Clicks on Maps Button',
          eventAction: 'Clicks on Open Map',
          eventLabel: ''
        })
      }
    },
    trackFooter (name) {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'generic_event',
          eventCategory: 'Footer',
          eventAction: name,
          eventLabel: ''
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.desktop-only {
  display: inline-block;
  vertical-align: middle;

  @include breakpoint ('xs-only') {
    display: none;
  }
}

.mobile-only {
  display: none;
  @include breakpoint ('xs-only') {
    display: block;
  }
}

.floors-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  pointer-events: none;

  &.gucci-app {
    bottom: 20px;
  }

  .button-map {
    pointer-events: all;
    outline: none;
  }

  a:hover {
    color: $c-pink;
  }
}

.footer-row {
  height: 81px;

  @include breakpoint ('xs-only') {
    height: 49px;
  }
}

.border-top {
  border-top: 1px solid $c-white-50;
}

a {
  pointer-events: all;
  color: $c-white;
  text-decoration: none;
  transition: all 0.2s ease-in-out;

  @include breakpoint ('sm-and-down') {
    display: block;
    line-height: 1;
  }

  @include breakpoint ('xs-only') {
    font-size: 12px;
  }
}
</style>
